<template>
  <td :class="cellClass">{{ emptyValue ? '-' : actualValue }}</td>
</template>

<script>
  import lodash from 'lodash';
  import { mapGetters } from 'vuex';
  import DataMethods from '../../../utils/DataMethods.js';

  export default {
    name: 'TableCellBase',
    mixins: [DataMethods],
    props: ['metric', 'monthObj', 'index'],
    computed: {
      ...mapGetters('allergyKpis', ['yearStart', 'month']),
      monthOffset() {
        return (((this.month - this.yearStart) + 12) % 12) + 1;
      },
      emptyValue() {
        return this.monthObj.empty;
      },
      cellClass() {
        let classes = [];
        if (this.monthOffset === parseInt(this.index) + 1) {
          classes.push('kpi-performance-table__month--selected');
        }
        if (this.emptyValue) {
          classes.push('kpi-table__data--empty');
        }
        return lodash.join(classes, ' ');
        // return (this.monthOffset === this.index + 1) ? 'kpi-performance-table__month--selected' : '';
      },
      type() {
        return this.metric.type;
      },
      field() {
        return this.metric.field;
      },
      actualValueRaw() {
        return this.monthObj[this.field] || 0;
      },
      actualValue() {
        return this.formatData(this.actualValueRaw);
      },
    },
    methods: {
      formatData(value) {
        // Customize return value depending on metric
        if (this.type == 'money') {
          return this.currency(value, '$');
        } else if (this.type == 'unit') {
          return this.currency(value);
        } else if (this.type == 'percent') {
          return this.round(this.getPercent(value), 2) + '%';
        }
        return value;
      },

      /**
       *  Method that helps avoid dividing by zero.
       *
       *  @param numerator A numeric value.
       *  @param denominator A numeric value.
       *  @param returnValueIfDenominatorIsInvalid Optional value to return if division by zero occurs.
       *  @return A ratio.
       */
      getRatio(numerator, denominator, returnValueIfDenominatorIsInvalid = false) {
        if (this.empty(parseFloat(denominator))) {
          return (returnValueIfDenominatorIsInvalid !== false) ? returnValueIfDenominatorIsInvalid : '';
        }
        if (this.empty(parseFloat(numerator))) {
          return 0;
        }
        return numerator / denominator;
      },

      /**
       *  Emulates PHP's empty() method.
       *
       *  @param data (mixed) A variable you want to determine if its empty.
       *  @return boolean
       */
      empty(data) {
        // If data is a number
        if (typeof (data) == 'number' || typeof (data) == 'boolean') {
          return (data == 0);
        }
        // If data is a string literally representing zero
        if (data == '0') {
          return true;
        }
        // All other cases (functions, regular expressions, elements, documents, etc)
        return lodash.isEmpty(data);
      },
    },
  };
</script>
